export const PREFIX = 'WHITE_LABELING_';

export const UPLOAD_LOGO_SUCCESS = PREFIX + 'UPLOAD_LOGO_SUCCESS';

export const DELETION_SUCCESS = PREFIX + 'DELETION_SUCCESS';